"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUrlConfigOverride = void 0;
const react_1 = require("react");
const url_override_1 = require("./url-override");
function useUrlConfigOverride(experimentId, configs) {
    const config = (0, react_1.useMemo)(() => (configs.length ? configs.find((config) => config.configId === experimentId) : undefined), [configs, experimentId]);
    const configOverride = (0, react_1.useMemo)(() => (0, url_override_1.getUrlOverrideConfig)(experimentId), [experimentId]);
    if (configOverride) {
        return configOverride;
    }
    return config;
}
exports.useUrlConfigOverride = useUrlConfigOverride;
//# sourceMappingURL=useUrlConfigOverride.js.map